import React, { useEffect } from "react";
// import { Card, CardBody, CardTitle } from "reactstrap";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import { googleWallet } from "@bkry/bowline-connectors";
import { FaInfoCircle } from "react-icons/fa";
import { getEnv } from "@bkry/bowline-utils";
import { setKeepWalletConnection } from "@bkry/bowline-redux/wallets";
import { useDispatch, useSelector } from "react-redux";

const AuthConnectButton = (props, context) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const dispatch = useDispatch();
  const suggestedChainOptions = useSelector(
    (state) => state.projects.defaultNetworks[REACT_APP_PROJECT_ID]
  );

  // useEffect(() => {
  //   void googleWallet
  //     .connectEagerly()
  //     .then(() => {
  //       console.debug("Connected eagerly to web3-auth");
  //       dispatch(setKeepWalletConnection({
  //         keepWalletConnection: true,
  //         lastProvider: "wta-google",
  //       }));
  //     })
  //     .catch(() => {
  //       console.debug("Failed to connect eagerly to web3-auth");
  //     });
  // }, []);

  // async function connectWallet() {
  //   try {
  //     //activate wallet connection
  //     return await activate(web3AuthConnector);
  //   } catch (exception) {
  //     console.log("exception", exception);
  //     return exception;
  //   }
  // }

  const handleConnect = () => {
    if (googleWallet) {
      googleWallet
        .setOptions({
          chainId: suggestedChainOptions?.chain_id,
          chainHex: suggestedChainOptions?.chain_hex,
          initOptions: {
            chainId: suggestedChainOptions?.chain_hex,
            rpcTarget: suggestedChainOptions
              ? `${suggestedChainOptions?.rpc_target}${getEnv(
                  "REACT_APP_INFURA_ID"
                )}`
              : undefined,
            displayName: "Ethereum Mainnet",
            blockExplorer: "https://etherscan.io",
            ticker: "ETH",
            tickerName: "Ethereum",
          },
          loginOptions:
            suggestedChainOptions?.wta_id &&
            suggestedChainOptions?.wta_google_id
              ? {
                  google: {
                    name: "Custom Auth Login",
                    verifier: suggestedChainOptions?.wta_google_verifier,
                    typeOfLogin: "google",
                    clientId: suggestedChainOptions?.wta_google_id,
                  },
                }
              : undefined,
          clientId: suggestedChainOptions?.wta_id,
        })
        .then(() => googleWallet.activate())
        .then(() => {
          console.log("connected");
          dispatch(
            setKeepWalletConnection({
              keepWalletConnection: true,
              lastProvider: "wta-google",
            })
          );
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className="text-center d-flex flex-column">
      <p className="h4 text-center fw-bold mb-4">
        {context.t("Connect with your Google Account")}
      </p>
      <Button
        onClick={handleConnect}
        className="mb-3"
        size="lg"
        color="primary"
      >
        {context.t("Connect with Google")}
      </Button>
      <p className="my-4">
        {context.t(
          "If you haven't yet obtained a crypto wallet, you have the option to utilize your current social accounts such as Google or Facebook to create a wallet."
        )}
      </p>
      <p className="mb-5">
        {context.t(
          "We do not possess access to your private keys, which means we are unable to manage your funds on your behalf. You, and only you, maintain complete control and ownership over your wallet and its associated private key."
        )}
      </p>
      <p className="mt-5 small text-muted">
        <FaInfoCircle className="me-1" />
        {context.t(
          "To establish a connection with your Google account, you will need to grant authorization to a trusted third-party application to create a Social Network Account that ensures the secure management of your non-custodial wallet."
        )}
      </p>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
AuthConnectButton.contextTypes = {
  t: PropTypes.func,
};

export default AuthConnectButton;
